import { type FC } from 'react'
import { LogOut } from 'lucide-react'
import type { Admin, Customer } from '@univdiam/ui/type';
import { Avatar, AvatarFallback, AvatarImage } from '@univdiam/ui/components/avatar';
import { Tooltip, TooltipTrigger, TooltipContent } from '../../components/tooltip';

type UserInfoPanelProps = {
  isExpanded: boolean;
  logoutUser: () => void
  user: Admin | Customer | null
}

const UserInfoPanel: FC<UserInfoPanelProps> = ({ isExpanded, logoutUser, user }) => {
  const profileLink = (
    <a href='/settings'>
      <div className={`flex items-center py-2 ${isExpanded ? 'gap-4 px-3' : 'justify-center'}`}>
        <Avatar>
          <AvatarImage src={user?.profile_pic!} className='w-8 h-8 rounded-full h-[100%]' />
          <AvatarFallback className='w-8 h-8 rounded-full h-[100%]'>{user?.full_name?.charAt(0)}</AvatarFallback>
        </Avatar>
        {isExpanded && (<div className='overflow-hidden'>
          <p className='text-body1 font-bold text-primary'>{user?.full_name}</p>
          <p className='text-body2 text-secondary truncate max-w-[140px]'>{user?.email}</p>
        </div>)}
      </div>
    </a>
  );

  const signOutButton = (
    <div className='' onClick={() => logoutUser()}>
      <div className={`py-2 hover:bg-[#f0f0f0] flex items-center text-sm text-[#444444] cursor-pointer hover:text-black transition-colors duration-200 ${isExpanded ? 'gap-2 px-3' : 'justify-center'}`}>
        <span><LogOut size={16} strokeWidth={1} /></span> {isExpanded && <div> Sign Out </div>}
      </div>
    </div>
  );

  return (
    <div className='border border-[#E9EAEB] rounded-[4px]' >
      {!isExpanded ? (
        <Tooltip>
          <TooltipTrigger asChild>
            {profileLink}
          </TooltipTrigger>
          <TooltipContent side="right" className="font-medium" sideOffset={8}>
            Settings
          </TooltipContent>
        </Tooltip>
      ) : (
        profileLink
      )}
      <div className='border-t border-[#E9EAEB]'></div>
      {!isExpanded ? (
        <Tooltip>
          <TooltipTrigger asChild>
            {signOutButton}
          </TooltipTrigger>
          <TooltipContent side="right" className="font-medium" sideOffset={8}>
            Sign Out
          </TooltipContent>
        </Tooltip>
      ) : (
        signOutButton
      )}
    </div>
  )
}

export default UserInfoPanel